import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { SharedConstants } from 'src/app/models/shared/shared.constants';

@Component({
  selector: 'app-icons-password',
  templateUrl: './icons-password.component.html'
})
export class IconsPasswordComponent implements OnInit, OnChanges {

  @Input() passwordValue: string;

  /** Check passwords */
  protected isANumber: boolean = false;
  protected isALetterLowerCase: boolean = false;
  protected isALetterUpperCase: boolean = false;
  protected isAChartEspecial: boolean = false;
  protected isAlmost8Charts: boolean = false;

  constructor (
    private sharedConstants: SharedConstants,
  ) {}

  public ngOnInit(): void {

  }

  public ngOnChanges(changes: SimpleChanges): void {
    if(changes['passwordValue']?.currentValue) {
      this.keyUpPassword(this.passwordValue);
    }
  }

  /** Method for detec when password changed */ 
  protected keyUpPassword(password: string): void{
    this.isANumber = (password?.search(this.sharedConstants.regexPattern.onlyNumber) >= 0);
    this.isALetterLowerCase = (password?.search(this.sharedConstants.regexPattern.onlyALetterLowerCase) >= 0);
    this.isALetterUpperCase = (password?.search(this.sharedConstants.regexPattern.onlyALetterUpperCase) >= 0);
    this.isAChartEspecial = (password?.search(this.sharedConstants.regexPattern.onlyAChartEspecial) >= 0);
    this.isAlmost8Charts = (password?.length >= 8 && password?.length <= 12);
  }

}
